module.exports = __webpack_public_path__ + "assets/675be02bd121b512481b62dc46504372.png";